let currentColorIndex = 0

export const COLORS = [
  '#EFF4FD',
  '#F1FAF8',
  '#FFFDF2',
  '#F0F9FD',
  '#FEF1F0',
  '#F4F3FB',
  '#F8F8F8'
]

export const getColor = () => {
  const color = COLORS[currentColorIndex]
  currentColorIndex = (currentColorIndex + 1) % COLORS.length
  return color
}
